let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c734x")).then(() => parcelRequire('3z0Mu'));